
import ApiResponse from "sr/models/ApiResponse";
import { get } from "sr/utils/axios";

export const getWorkorderStatus = async () => {
  return await get<ApiResponse<any[]>>("/WorkorderStatus").then((res)=>{
      return res
    })
};

 